import Books from "./Books";
import Timing from "./Timing";
class Management {
    books;
    booksClose;
    booksSubject;
    combinedBooks;
    hedgeDeadline;
    freeToTrade;
    status;
    timeOfExecution;
    constructor(response) {
        this.books = response.books !== undefined ? new Books(response.books) : undefined;
        this.booksClose = response.booksClose !== undefined ? new Timing(response.booksClose) : undefined;
        this.booksSubject = response.booksSubject !== undefined ? new Timing(response.booksSubject) : undefined;
        this.combinedBooks = response.combinedBooks !== undefined ? new Books(response.combinedBooks) : undefined;
        this.hedgeDeadline = response.hedgeDeadline !== undefined ? new Timing(response.hedgeDeadline) : undefined;
        this.freeToTrade = response.freeToTrade !== undefined ? new Timing(response.freeToTrade) : undefined;
        this.status = response.status;
        this.timeOfExecution = response.timeOfExecution !== undefined ? new Timing(response.timeOfExecution) : undefined;
    }
}
export default Management;
